// frontend/src/components/ConfirmModal.js
import React from 'react';
import '../styles/ConfirmModal.css';

const renderTextOrNode = (value) => {
  if (React.isValidElement(value)) return value;
  if (typeof value === 'string' || typeof value === 'number') return value;
  if (value && typeof value === 'object') return value.message ?? String(value);
  return null;
};

const ConfirmModal = React.memo(function ConfirmModal({
  isOpen,
  title,
  message,
  confirmText = 'OK',
  cancelText = 'Cancel',
  confirmButtonType = 'primary',
  onConfirm,
  onCancel
}) {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel?.();
    }
  };

  return (
    <div className="confirm-modal-overlay" onClick={handleOverlayClick} role="dialog" aria-modal="true">
      <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
        {title !== undefined && (
          <div className="confirm-modal-header">
            <h3 className="confirm-modal-title">{renderTextOrNode(title)}</h3>
          </div>
        )}

        {message !== undefined && (
          <div className="confirm-modal-body">
            {renderTextOrNode(message)}
          </div>
        )}

        <div className="confirm-modal-actions">
          <button className="btn-optimized btn-secondary" onClick={onCancel}>
            {cancelText}
          </button>
          <button
            className={`btn-optimized ${confirmButtonType === 'danger' ? 'btn-danger' : 'btn-primary'}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
});

ConfirmModal.displayName = 'ConfirmModal';
export default ConfirmModal;
